import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';
import RewardCampaignModel from '../model/RewardCampaignModel.js';
import RewardCategoryModel from '../model/RewardCategoryModel.js';

export default {
    /**
     * @param {String} strBzbsToken
     * @param {Object} objListConfig (Require) CampaignListConfigModel - /core/Campaign/model/CampaignConfigModel.js
     * @param {Object} objListFilterConfig (Optional) CampaignListFilterConfigModel - /core/Campaign/model/CampaignConfigModel.js
     */
    apiGetCampaign: function (strBzbsToken, objListConfig, objListFilterConfig) {
        var params = objListConfig.getParams();
        if (objListFilterConfig != null) {
            var filter = objListFilterConfig.getParams();
            params = {...params , ...filter};
        }

        var strUrl = Vue.bzbsConfig.bzbsModuleUrl + "/campaign";
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(strUrl, strBzbsToken, params).then((response) => {
                var arrCampaign = [];
                for (var i of response.data) {
                    var objCampaign = new RewardCampaignModel(i);
                    arrCampaign.push(objCampaign);
                }

                resolve(arrCampaign);
            }).catch((error) => {
                reject(error);
            });
        });
    },
    /**
      * @param {String} token
      * @param {Object} categoryParam CategoryConfigModel - /core/Campaign/model/CategoryConfigModel.js
      */
     apiGetCategory: function (token, categoryParam) {
        var url = Vue.bzbsConfig.bzbsModuleUrl + "/campaigncat/menu";
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(url, token, categoryParam)
                .then((response) => {
                    var categories = [];
                    for (var i of response.data) {
                        var category = new RewardCategoryModel(i);
                        categories.push(category);
                    }

                    resolve(categories);
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    /**
     * Redeem campaign
     * @param {String} token
     * @param {Object} redeemParam
     */
    apiRedeemCampaign: function (token, id, redeemParam) {
        var url = `${Vue.bzbsConfig.bzbsUrl}/campaign/${id}/redeem`;
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(url, token, redeemParam)
                .then(response => {
                    var data = response.data;

                    resolve(data);
                }).catch(error => {
                    reject(error);
                });
        });
    },

    /**
     * Redeem campaign
     * @param {String} token
     * @param {Object} redeemParam
     */
    apiRedeemCampaignCustom: function (token, redeemParam) {
        var url = `${Vue.bzbsConfig.bzbsUrl}/redeem`;
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPostJson(url, token, redeemParam)
                .then(response => {
                    var data = response.data;
                    resolve(data);
                }).catch(error => {
                    reject(error);
                });
        });
    },

     /**
      * Cancel redeem
      * @param {String} token
      * @param {String} serial
      */
    apiCancelRedemption: function (token, serial) {
        // var params = {
        //     code: serial
        // };
        //var url = Vue.bzbsConfig.bzbsUrl + '/campaign/cancel_serial';
        var url = `${Vue.bzbsConfig.bzbsModuleUrl}/serial/${serial}/cancel`;
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(url, token)
                .then(response => {
                    console.log('cancel redepmtion', response);
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }
}
